import gql from 'graphql-tag'

export const ClipFeedback_clip = gql`
  fragment ClipFeedback_clip on Clip {
    id
    feedback {
      positive
    }
  }
`



// WEBPACK FOOTER //
// ./src/routes/video/components/ClipFeedback.fragments.js